module.exports = __webpack_public_path__ + "files/d9fe3b1e6f3e69fd12b723f9bfeb80b8.png";